import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Avatar, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fade, FormControlLabel, Grid, IconButton, LinearProgress, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Switch, Tooltip, Typography } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import { Cliente } from './Cliente';
import { DataGrid, GridRowSelectionModel, GridRowId, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { AvatarColor } from '../models/AvatarColor';
import EntitySettings from '../components/EntitySettings';
import ClienteNew from './ClienteNew';
import ClienteDelete from './ClienteDelete';
import ClienteEdit from './ClienteEdit';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FeatureManager from '../components/Utilities/FeatureManager';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'clientes' })}
        >
            Exportar CSV
        </Button>
    );
}

export interface IClientesState {
    data: Cliente[];
    loading: boolean;
    selectedSex: string;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedCliente: GridRowId[];
    progress: number;
    progressMessage: string;
    checkBoxSelection: boolean;
    errors: string[];
    rowSelected: null | HTMLElement;
    openRowMenu: boolean;
}

export default class ClientesView extends React.Component<{}, IClientesState> {
    _file: any;
    _fileContent: any[] = [];
    _errors: string[] = [];
    _avatarColors: AvatarColor[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedCliente: [],
            checkBoxSelection: false,
            progress: 0,
            progressMessage: '',
            rowSelected: null,
            openRowMenu: false,
            errors: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Clientes} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Clientes} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Clientes',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <HandshakeOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Clientes
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Clientes}/>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length > 0 && (
                                    <DataGrid
                                        autoHeight
                                        loading={this.state.data.length == 0}
                                        slots={{ toolbar: this.CustomToolbar.bind(this) }}
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        rows={this.state.data}
                                        columns={[
                                            { 
                                                field: 'id', 
                                                headerName: 'ID', 
                                                width: 100,
                                                renderCell: ({ row }) => (
                                                    this.RenderIconStatus(row, 'id')
                                                )
                                            },
                                            { 
                                                field: 'vertical', 
                                                headerName: 'Vertical', 
                                                width: 100 
                                            },
                                            { 
                                                field: 'razonSocial', 
                                                headerName: 'Razón social', 
                                                width: 200 
                                            },
                                            { 
                                                field: 'defaultFallow', 
                                                headerName: 'Barbecho por defecto', 
                                                width: 150,
                                                renderCell: ({ row }) => (
                                                    this.RenderDefaultFallow(row)
                                                )
                                            },
                                            { 
                                                field: 'cif', 
                                                headerName: 'CIF', 
                                                width: 100
                                            },
                                            { 
                                                field: 'direccion', 
                                                headerName: 'Dirección', 
                                                width: 350
                                            },
                                            { 
                                                field: 'codigoPostal', 
                                                headerName: 'Código postal', 
                                                width: 100
                                            },
                                            { 
                                                field: 'localidad', 
                                                headerName: 'Localidad', 
                                                width: 200
                                            },
                                            { 
                                                field: 'provincia', 
                                                headerName: 'Provincia', 
                                                width: 200
                                            },
                                            { 
                                                field: 'pais', 
                                                headerName: 'País', 
                                                width: 200
                                            },
                                            { 
                                                field: 'creadoPor', 
                                                headerName: 'Creado por', 
                                                width: 200,
                                                renderCell: ({ row }) => (
                                                    Common.RenderUser(row, 'creadoPor')
                                                )
                                            },
                                            { 
                                                field: 'creado', 
                                                headerName: 'Creado', 
                                                width: 150,
                                                renderCell: ({ row }) => (
                                                    Common.RenderDate(row, 'creado')
                                                )
                                            },
                                            { 
                                                field: 'modificadoPor', 
                                                headerName: 'Modificado por', 
                                                width: 200,
                                                renderCell: ({ row }) => (
                                                    Common.RenderUser(row, 'modificadoPor')
                                                )
                                            },
                                            { 
                                                field: 'modificado', 
                                                headerName: 'Modificado', 
                                                width: 150,
                                                renderCell: ({ row }) => (
                                                    Common.RenderDate(row, 'modificado')
                                                )
                                            }
                                        ]}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 },
                                            },
                                        }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={this.state.checkBoxSelection}
                                        onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                            this.setState({
                                                selectedCliente: row,
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openDeleteForm: false,
                                                openEditForm: false
                                            });
                                        }}
                                        hideFooter={this.state.data.length <= 30}
                                    />
                                )
                            }
                        </Box>
                        <ClienteNew open={this.state.openNewForm} onSave={this.Get.bind(this)} />
                        <ClienteDelete open={this.state.openDeleteForm} id={this.state.selectedCliente as number[]} onDelete={this.Get.bind(this)} />
                        <ClienteEdit open={this.state.openEditForm} onSave={this.Get.bind(this)} selectedItem={this.GetSelectedCliente()}/>
                        <Dialog open={this.state.openImportProgress} fullWidth>
                            <DialogTitle>
                                Importando Clientes
                            </DialogTitle>
                            <DialogContent>
                                <Grid item xs={12} style={{padding: '20px 10px'}}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <LinearProgress variant="determinate" value={this.state.progress} />
                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {
                                                    `${this.state.progress}%`
                                                }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog open={this.state.errors.length > 0} fullWidth>
                            <DialogTitle>
                                Error
                            </DialogTitle>
                            <DialogContent>
                                <Typography variant='body2'>
                                    Se han producido los siguientes errores durante la importación:
                                </Typography>
                                <div className='errors'>
                                    <List>
                                        {
                                            this.state.errors.map((value: string, index: number) => {
                                                return (
                                                    <ListItem disablePadding>
                                                        <ListItemButton>
                                                            <ListItemIcon>
                                                                <CancelOutlinedIcon />
                                                            </ListItemIcon>
                                                            <ListItemText primary={value} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )
                                            })
                                        }
                                    </List>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => {
                                    this.setState(
                                        {
                                            errors: []
                                        }
                                    );
                                }}>Ok</Button>
                            </DialogActions>
                        </Dialog>
                        <Menu
                            anchorEl={this.state.rowSelected}
                            open={this.state.openRowMenu}
                            onClose={() => {
                                this.setState(
                                    {
                                        rowSelected: null,
                                        openRowMenu: false
                                    }
                                );
                            }}
                        >
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <EditIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Modificar</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Eliminar</ListItemText>
                            </MenuItem>
                        </Menu>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private GetSelectedCliente(): Cliente | undefined {
        const cliente = this.state.data.find((value: Cliente) => {
            return value.id == this.state.selectedCliente[0] as number;
        });

        console.log(cliente);

        return cliente;
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/clientes`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log('Cliente', response);
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedCliente: [],
                    loading: false,
                    progress: 0
                }
            );
        })
    }

    private RenderDefaultFallow(row: any): JSX.Element {
        return (
            <span>
                {
                    !isNaN(row['defaultFallow']) && (
                        row['defaultFallow'].toString()
                    )
                }
            </span>
        )
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <FeatureManager entidad={Entity.Clientes} operacion='Crear'>
                    <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Crear}>
                        <Button startIcon={<AddOutlinedIcon />} variant="contained" onClick={() => {
                            this.setState(
                                {
                                    openNewForm: true,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}>
                            Nuevo
                        </Button>
                    </SecurityTrimmer>
                </FeatureManager>
                {
                    this.state.selectedCliente.length == 1 && (
                        <FeatureManager entidad={Entity.Clientes} operacion='Editar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Editar}>
                                <Button startIcon={<EditOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false
                                        }
                                    );
                                }}>
                                    Modificar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    this.state.selectedCliente.length > 0 && (
                        <FeatureManager entidad={Entity.Clientes} operacion='Eliminar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Eliminar}>
                                <Button startIcon={<DeleteOutlineOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true
                                        }
                                    );
                                }}>
                                    Eliminar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    ExportButton()
                }
                <Stack direction={'row'} style={{marginLeft: 'auto'}} justifyContent={'space-between'}>
                    <FormControlLabel control={<Switch defaultChecked={this.state.checkBoxSelection} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        this.setState(
                            {
                                checkBoxSelection: event.target.checked,
                                openNewForm: false,
                                openImportProgress: false,
                                openEditForm: false,
                                openDeleteForm: false
                            }
                        );
                    }}/>} label={<Typography variant='body2' color={'text.secondary'}>Selección múltiple</Typography>} />
                </Stack>
            </Stack>
        )
    }

    private RenderIconStatus(row: any, key: string): JSX.Element {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Editar}>
                <Button variant='text' style={{color: '#333'}} onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    this.setState(
                        {
                            rowSelected: event.currentTarget,
                            openRowMenu: true
                        }
                    );
                }}>
                    {
                        row[key]
                    }
                </Button>
            </SecurityTrimmer>
        )
    }
}